import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearVisitsActions, getVisitsActions } from '../../redux/actions/visitsActions';

const useFetchVisits = () => {
  const dispatch = useDispatch();
  const vin = useSelector((state) => state.vehicle.vehicle?.vin);
  const search = useSelector((state) => state.visits?.search);
  const visits = useSelector((state) => state.visits?.visits);
  const loading = useSelector((state) => state.visits?.loading);

  const fetchVisits = useCallback(async () => {
    await dispatch(getVisitsActions(search, vin));
  }, [vin, search, dispatch]);

  useEffect(() => {
    fetchVisits();
  }, [fetchVisits]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitsActions());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisits();
  };

  return { loading, visits, refresh };
};

export default useFetchVisits;
